module.exports = __webpack_public_path__ + "8399239db68721e30e1c4e5559820730.woff";